export const TmetricSettingsGetters = {
  tmetricAPIKeyValid: state => !!state.tmetricAPIKeyValid,
  tmetricEnableDetails: state => state.tmetricEnableDetails,
  tmetricSettings: state => state.tmetricSettings,
  tmetricSettingsId: state => !!state.tmetricSettings?.id,
  tmetricSettingsLoading: state => state.tmetricSettingsLoading,
  tmetricSettingsValue: state => state.tmetricSettings?.value,
  tmetricWorkspaceName: (state, getters) => state.tmetricWorkspaces?.
    find(w => w.accountId === getters.tmetricSettingsValue?.tmetric_account_id)?.
    accountName,
  tmetricWorkspaces: state => state.tmetricWorkspaces,
  tmetricSettingsApiKey: (_, getters) => getters.tmetricSettingsValue?.tmetric_api_key,
}
